import React from 'react';
import { useTranslation } from 'react-i18next';
import { useCurrentTool } from '@/shared/hooks/useCurrentTool'
import { GradientBorder } from '@/shared/components/GradientBorder'
import RecordForm from '@/features/generation/RecordForm';
import succeedIcon from '@/images/SVG/succeedIcon.svg';

const FormState = ({ 
  mode, // 'record' or 'upload'
  recordingTime,
  audioDuration,
  selectedFile,
  recordedBlob,
  formatTime,
  onGenerateReport,
  setGenerateReport,
  nonAudioTool,
  draftFormData
}) => {
  const { t } = useTranslation();
  const { generation_name } = useCurrentTool();
  
  const isMultipleFiles = nonAudioTool && Array.isArray(selectedFile);
  const fileCount = isMultipleFiles ? selectedFile.length : 1;

  const getTitle = () => {
    if (mode === 'record') {
      return `${t('reports.generate.record.recorded')} (${formatTime(recordingTime)})`;
    }
    if (isMultipleFiles && fileCount > 1) {
      return t('reports.generate.file.selectedMultiple', { count: fileCount });
    }
    return `${t('reports.generate.file.selected')} ${nonAudioTool ? '' : `(${formatTime(audioDuration)})`}`;
  };

  const getMediaBlob = () => {
    return mode === 'record' ? recordedBlob : selectedFile;
  };

  return (
    <div className='flex flex-col justify-center items-center w-full overflow-y-auto'>
      <GradientBorder>
        <div className="shadow-sm bg-white rounded-full p-3">
          <img className='max-w-none w-4 h-4' src={succeedIcon} alt='success' />
        </div>
      </GradientBorder>
      
      <h1 className='font-bold mt-[16px] font-SuisseIntlLight md:text-[24px] text-xl'>
        {getTitle()}
      </h1>
      
      <p className='sm:w-[320px] max-w-[320px] mt-[4px] mb-[12px] text-[#505050] text-[16px] font-SuisseIntlLight font-normal'>
        {t('reports.generate.fillForm', { type: generation_name.toLowerCase() })}
      </p>
      
      <RecordForm 
        GenerateReport={setGenerateReport} 
        handleGenerateReport={onGenerateReport} 
        recordedAudioBlob={getMediaBlob()}
        draftFormData={draftFormData}
      />
    </div>
  );
};

export default FormState;